export default __webpack_public_path__ + "static/media/FONDO_SMART_TRADING.12d7477d.svg";